const translations = {
    changePilot: 'Change Pilot'
};

export default translations;
